import moment from "moment";

export const configHorarioAtendimentoTabs = {
  INFORMACOES: 0,
  PROCEDIMENTOS: 1,
  AUDITORIA: 2,
};

export const defaultProcedimentosModalData = {
  isOpen: false,
  diaSemana: "",
  horaInicio: "",
  convenios: [],
};

export const columns = [
  {
    Header: "Tempo de atendimento",
    getValue: (row) => {
      return row.duracao
        ? `${row.duracao} minuto${parseInt(row.duracao) > 1 ? "s" : ""}`
        : "-";
    },
    props: { center: "true" },
  },
  {
    Header: "Horário Início",
    getValue: (row) => {
      return row.horaInicioPeriodoAtendimento || "-";
    },
    props: { center: "true" },
  },
  {
    Header: "Horário Fim",
    getValue: (row) => {
      return row.horaFimPeriodoAtendimento || "-";
    },
    props: { center: "true" },
  },
  {
    Header: "Começo Vigência",
    getValue: (row) => {
      return row.dataInicioVigencia
        ? moment(row.dataInicioVigencia).format("DD/MM/YYYY")
        : "-";
    },
    props: { center: "true" },
  },
  {
    Header: "Final Vigência",
    getValue: (row) => {
      return row.dataFimVigencia
        ? moment(row.dataFimVigencia).format("DD/MM/YYYY")
        : "-";
    },
    props: { center: "true" },
  },
];

export const notificationDefault = { 
  open: false, 
  message: "", 
  type: "" 
};